export default __webpack_public_path__ + "f9c7a689b2cf46fd9f60457ece4dec6c.png";